import { render } from "./ViewBlog.vue?vue&type=template&id=b63eb5aa"
import script from "./ViewBlog.vue?vue&type=script&lang=js"
export * from "./ViewBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__